import React from 'react';

const TwitterShareButton = ({ text, url, hashtags }) => {
    const handleShare = () => {
      // Create the post content
      const shareText = encodeURIComponent(text || '');
      const shareUrl = encodeURIComponent(url || window.location.href);
      const shareHashtags = hashtags ? encodeURIComponent(hashtags.join(',')) : '';
      
      // Construct the Twitter intent URL (still uses twitter.com domain)
      const xIntentUrl = `https://twitter.com/intent/tweet?text=${shareText}&url=${shareUrl}${shareHashtags ? `&hashtags=${shareHashtags}` : ''}`;
      
      // Redirect to X
      window.open(xIntentUrl, '_blank', 'width=550,height=420');
    };
  
    return (
      <button 
        onClick={handleShare}
        className="x-share-button"
        style={{
          backgroundColor: '#000000',
          color: 'white',
          padding: '10px 15px',
          borderRadius: '4px',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '14px',
          fontWeight: 'bold',
          transition: 'background-color 0.2s ease'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#333333'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#000000'}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
        Share on X
      </button>
    );
  };
  
  export default TwitterShareButton;